<template>
  <header>
    <nav class="navbar navbar-light">
      <a href="#" class="header__icon" id="header__icon" v-on:click.stop.prevent="toggleMenu"></a>
      <a class="navbar-brand" href="/">
        <img src="https://www.21-interactive.com/CONTEXTART.jpg" height="60" alt="Logo" class="d-inline-block align-top">
      </a>
      <ul class="nav navbar-nav float-xs-right">
        <!--<google-login></google-login>!-->
        <logout></logout>
        <a href="#" class="rightcolumn__icon" id="rightcolumn__icon" v-on:click.stop.prevent="toggleRightColumn"></a>
      </ul>
    </nav>
  </header>
</template>

<script>
  import GoogleLogin from 'src/components/google/Login.vue'
  import LogoutComponent from './Logout.vue'
  import $ from 'jquery'

  export default{
    data () {
      return {}
    },
    components: {
      googleLogin: GoogleLogin,
      logout: LogoutComponent
    },
    methods: {
      toggleMenu: function () {
        $('body').toggleClass('with--sidebar')
      },
      toggleRightColumn: function () {
        console.log('toggle')
        $('#Rightcolumn').toggleClass('hidden-xl-down')
        $('.bloc-center-row').toggleClass('no-right-column')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Header.vue?1698575e